import { RootState } from '../types'

export const getMainAdminSelector = (state: RootState) => state.admin

